import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=e356df1a&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e356df1a')) {
      api.createRecord('e356df1a', component.options)
    } else {
      api.reload('e356df1a', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=e356df1a&", function () {
      api.rerender('e356df1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TPEForm/components/Result/Result.vue"
export default component.exports